import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { useTranslation } from 'react-i18next'

import SecondaryButton from '../common/buttons/SecondaryButton';
import EditButton from '../common/buttons/EditButton';
import DeleteButton from '../common/buttons/DeleteButton';
import AddQuestionModalContent from './AddQuestionModalContent';
import useStyles from './styles';
import { ModalManagerContext } from '../ModalsManager';
import ErrorMessage from '../common/inputs/ErrorMessage';


const CampaignFormQuestionnaire = ({
  questions, setFieldValue, editMode, id,
}) => {
  const { t } = useTranslation(['translation'])

  const openModal = useContext(ModalManagerContext);

  const addQuestion = newQuestion => {
    setFieldValue([...questions, newQuestion]);
  };

  const classes = useStyles();
  const showModal = (callback, additionalData) => {
    openModal(
      AddQuestionModalContent,
      callback,
      additionalData,
      classes.modal,
    );
  };


  const openEditQuestionModal = question => {
    showModal(
      newQuestion => new Promise(resolve => {
        setFieldValue(questions.map(q => (q === question ? newQuestion : q)));
        return resolve();
      }),
      { question, editMode },
    );
  };

  const deleteQuestion = questionId => {
    setFieldValue(questions.filter(q => q.id !== questionId));
  };

  const openAddQuestionModal = () => {
    showModal(
      question => new Promise(resolve => {
        addQuestion(question);
        return resolve();
      }),
    );
  };

  return (
    <div className={classes.questionnaire}>
      {questions && (
        <ListGroup>
          {questions.map(q => (
            <ListGroupItem key={q.id} className={classes.listItem}>
              <span className={classes.questionName}>{q.name}</span>
              <div className={classes.rightPart}>
                <span className={classes.questionType}>{q.type}</span>
                <EditButton onClick={() => { openEditQuestionModal(q); }} />
                {!editMode && <DeleteButton onClick={() => { deleteQuestion(q.id); }} />}
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
      <ErrorMessage id={id} />
      {!editMode && (
        <SecondaryButton
          className={classes.addQuestionButton}
          onClick={openAddQuestionModal}
        >
          {t('CAMPAIGN.QUESTIONNAIRE.BUTTON_TEXT')}
        </SecondaryButton>
      )}
    </div>
  );
};


CampaignFormQuestionnaire.propTypes = {
  questions: PropTypes.array.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

export default CampaignFormQuestionnaire;
